/* Homepage behaviour ported from zcrave.com (goya-child blocks + typed.js + slick configs). */
(function () {
  'use strict';
  var live = { loop: false, align: 'start', duration: 25, inViewThreshold: 0.3, dragFree: false, watchDrag: true, slidesToScroll: 1, containScroll: 'trimSnaps' };
  function opts(extra) { var o = {}; for (var k in live) o[k] = live[k]; for (var j in extra) o[j] = extra[j]; return o; }

  /* ---- typed line (et-autotype): typeSpeed=data-speed, backSpeed 20, startDelay 1000, backDelay 1000, loop ---- */
  function humanize(s) { return Math.round(Math.random() * s / 2) + s; }
  function initTyped() {
    document.querySelectorAll('[data-autotype]').forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = '1';
      var entry = el.querySelector('.et-animated-entry'); if (!entry) return;
      var strings; try { strings = JSON.parse(entry.dataset.strings || '[]'); } catch (e) { strings = []; }
      if (!strings.length) return;
      var typeSpeed = Number(el.dataset.speed) || 50, backSpeed = 20, startDelay = 1000, backDelay = 1000;
      var si = 0;
      function typeChar(str, i) {
        if (i <= str.length) { entry.textContent = str.slice(0, i); setTimeout(function () { typeChar(str, i + 1); }, humanize(typeSpeed)); }
        else setTimeout(function () { backChar(str, str.length); }, backDelay);
      }
      function backChar(str, i) {
        if (i >= 0) { entry.textContent = str.slice(0, i); setTimeout(function () { backChar(str, i - 1); }, humanize(backSpeed)); }
        else { si = (si + 1) % strings.length; setTimeout(function () { typeChar(strings[si], 0); }, 0); }
      }
      setTimeout(function () { typeChar(strings[0], 0); }, startDelay);
    });
  }

  /* ---- CELEBS COVETED: slick centerMode/infinite/autoplay 2500/speed 600 port on Embla ---- */
  function initPress() {
    if (!window.EmblaCarousel) return;
    document.querySelectorAll('[data-press]').forEach(function (sec) {
      var node = sec.querySelector('[data-press-embla]'); if (!node || node.dataset.ready) return; node.dataset.ready = '1';
      var slides = node.querySelectorAll('.zc-press__slide');
      var embla = window.EmblaCarousel(node, { loop: true, align: 'center', containScroll: false, dragFree: false, duration: 20, slidesToScroll: 1 });
      function paint() { var s = embla.selectedScrollSnap(); slides.forEach(function (el, i) { el.classList.toggle('is-selected', i === s); }); }
      embla.on('select', paint); embla.on('init', paint); paint();
      var timer = null;
      function start() { stop(); timer = setInterval(function () { embla.scrollNext(); }, 2500); }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
      embla.on('pointerDown', stop); embla.on('pointerUp', start);
      // live column rises in when it enters the viewport (animation bottom-to-top)
      var col = sec.querySelector('[data-press-col]');
      if (col) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { col.classList.add('animated'); io.disconnect(); } }); }, { threshold: 0.1 });
          io.observe(col);
        } else col.classList.add('animated');
      }
    });
  }

  /* ---- PRODUCT SHOWCASE: nite-riot case slider (EmblaCarousel loop/center/duration 18/skipSnaps, no autoplay).
     Names drive the stacks: active gets is-active (z3, opens over .5s), the one it replaces keeps is-previous (z2,
     stays open underneath), everything else resets. Counter digits roll like the reference (yPercent, .25s). ---- */
  function initShowcase() {
    if (!window.EmblaCarousel) return;
    document.querySelectorAll('[data-showcase]').forEach(function (wrapper) {
      var emblaNode = wrapper.querySelector('[data-showcase-embla]'); if (!emblaNode || emblaNode.dataset.ready) return; emblaNode.dataset.ready = '1';
      var embla = window.EmblaCarousel(emblaNode, { loop: true, duration: 18, startIndex: 0, slidesToScroll: 1, align: 'center', skipSnaps: true });
      var items = Array.prototype.slice.call(wrapper.querySelectorAll('[data-showcase-item]'));
      var slides = embla.slideNodes();
      var tens = wrapper.querySelector('[data-showcase-tens]'), ones = wrapper.querySelector('[data-showcase-ones]'), count = wrapper.querySelector('[data-showcase-count]');
      var n = slides.length, previous = null, row = 12;
      if (tens && ones && count) {
        count.textContent = String(n).padStart(2, '0');
        var tensSet = []; for (var i = 1; i <= n; i++) { var t = Math.floor(i / 10); if (tensSet.indexOf(t) < 0) tensSet.push(t); }
        tens.innerHTML = tensSet.map(function (t) { return '<span>' + t + '</span>'; }).join('');
        var onesHtml = ''; for (var k = 1; k <= n; k++) onesHtml += '<span>' + (k % 10) + '</span>';
        ones.innerHTML = onesHtml;
      }
      function paginate(s) {
        if (!tens || !ones) return;
        tens.style.transform = 'translateY(' + (-Math.floor(s / 10) * row) + 'px)';
        ones.style.transform = 'translateY(' + (-s * row) + 'px)';
      }
      function paint() {
        var s = embla.selectedScrollSnap();
        slides.forEach(function (el, i) { el.classList.toggle('is-active', i === s); });
        items.forEach(function (item, i) {
          var active = i === s, prev = previous !== null && i === previous && !active;
          if (active && !item.classList.contains('is-active') && previous !== null) {
            item.classList.add('is-entering');
            setTimeout(function () { item.classList.remove('is-entering'); }, 520);
          }
          item.classList.toggle('is-active', active);
          item.classList.toggle('is-previous', prev);
        });
        previous = s;
        paginate(s);
      }
      embla.on('select', paint);
      embla.on('reInit', paint);
      slides.forEach(function (slide, i) { slide.addEventListener('click', function () { embla.scrollTo(i); }); });
      var prevBtn = wrapper.querySelector('[data-showcase-prev]'), nextBtn = wrapper.querySelector('[data-showcase-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { embla.scrollPrev(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { embla.scrollNext(); });
      paint();
    });
  }

  function init() { initTyped(); initPress(); initShowcase(); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
})();
